import { ObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useRef } from 'react';

interface PropertyIdentifier {
  propertyName: string;
  objectTypeId: ObjectTypeId;
  objectId: string;
}

export type SetIsEditingFunction = (
  args: PropertyIdentifier & {
    isEditing: boolean;
  }
) => void;

export type GetIsEditingFunction = (args: PropertyIdentifier) => boolean;

interface UseEditingStateResult {
  setIsEditing: SetIsEditingFunction;
  getIsEditing: GetIsEditingFunction;
}

const createPropertyKey = (identifier: PropertyIdentifier) =>
  `${identifier.propertyName}-${identifier.objectTypeId}-${identifier.objectId}`;

export const useAutosaveEditingState = (): UseEditingStateResult => {
  const isEditingRef = useRef(new Set<string>());

  const getIsEditing: GetIsEditingFunction = useCallback(
    (identifier) => isEditingRef.current.has(createPropertyKey(identifier)),
    []
  );

  const setIsEditing: SetIsEditingFunction = useCallback(
    ({ propertyName, objectTypeId, objectId, isEditing }) => {
      const identifier = { propertyName, objectTypeId, objectId };
      if (isEditing) {
        isEditingRef.current.add(createPropertyKey(identifier));
      } else {
        isEditingRef.current.delete(createPropertyKey(identifier));
      }
    },
    []
  );

  return { getIsEditing, setIsEditing };
};
